import type {
  ReproduceRun_FileFragment as FileInfo,
  ReproduceRun_RunFragment as RunInfo,
} from '../../generated/graphql';
import {
  DIFF_FILE_REGEX_WITH_OPTIONAL_SHA,
  DIFF_FILE_REGEX_WITH_SHA,
} from '../../util/constants';

type Files = RunInfo['reproduceRunFiles'];

// Expects a list of files that contains patch files. One should be `diff.patch`
// possibly one other would be `diff_{sha}.patch`. If there  are two, we want to
// use the one with the sha in the name, since that's the one that will get
// maximum reproducability. Otherwise, the `diff.patch` is sufficient.
//
// If neither are found, the working tree and the remote are identical and we
// can safely ignore the "get the patch file and apply it" steps in the repro
// instructions.
export function findPatchFile(files: Files): FileInfo | null {
  const fileEdges = (files?.edges || []).filter(f =>
    f.node?.name.match(DIFF_FILE_REGEX_WITH_OPTIONAL_SHA)
  );

  if (fileEdges.length > 1) {
    const diffWithSha = fileEdges.find(f =>
      f.node?.name.match(DIFF_FILE_REGEX_WITH_SHA)
    )?.node;

    // If we have a diff_{sha}.patch, return that preferentially. Otherwise,
    // return the first. This might be somewhat unsound, if the user has
    // run.save()-d files that match this regex. That seems unlikely, though,
    // and I don't think there's a way to detect SDK-generated diff.patch files
    // and files the user might have saved that match that naming pattern.
    if (diffWithSha) {
      return diffWithSha;
    }
  }
  if (fileEdges[0]) {
    return fileEdges[0].node ?? null;
  }
  return null;
}
